<template>
  <div class="modaladmin">
    <div class="modaladmin-content">
      <div class="error" v-for="(error, index) in errors" v-bind:key="index">{{ error }}</div>
      <div>
        IME:
        <input type="text" v-model="venue.name" />
      </div>
      <div>
        LOKACIJA:
        <input type="text" v-model="venue.location" />
      </div>
      <div class="modaladmin-footer">
        <button type="button" v-bind:disabled="!venue.name" v-on:click="validateAndSave()">SPREMI</button>
        <button type="button" v-on:click="$emit('cancel', venue)">ODUSTANI</button>
      </div>
    </div>
    <a aria-label="Zatvori popup" class="close-modaladmin" v-on:click="$emit('cancel', venue)"></a>
  </div>
</template>

<script>
export default {
  name: 'AddEditVenueModal',
  data() {
    return {
      errors: [],
    };
  },
  props: {
    venue: {},
  },
  methods: {
    validateAndSave: function() {
      if (this.validate()) this.$emit('save', this.venue);
    },
    validate: function() {
      this.errors = [];

      if (!this.venue.name) this.errors.push('Ime prostorije ne može biti prazno.');

      if (this.errors.length) return false;

      return true;
    },
  },
};
</script>
